/**
 * Immunization Service
 * Patient immunization records and vaccine tracking API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocationExpandDto } from './locationExpandDto';
import { ReferenceDto } from './referenceDto';
import { ImmunizationTypeResponseDto } from './immunizationTypeResponseDto';
import { PerformerDto } from './performerDto';
import { ReactionDto } from './reactionDto';
import { NoteDto } from './noteDto';
import { ProtocolAppliedDto } from './protocolAppliedDto';


export interface ImmunizationResponseDto { 
    /**
     * Immunization record ID
     */
    id: string;
    /**
     * Tenant identifier
     */
    tenantId: string;
    /**
     * Patient identifier
     */
    patientId: string;
    /**
     * Immunization type element ID
     */
    elementId: string;
    /**
     * Collection ID the element belongs to
     */
    collectionId: string;
    /**
     * Immunization status
     */
    status: ImmunizationResponseDto.StatusEnum;
    /**
     * Status reason element ID
     */
    statusReason?: string;
    /**
     * Date/time when the immunization was administered (ISO 8601). Null for open immunizations.
     */
    occurrenceDateTime?: string;
    /**
     * When the immunization was recorded (ISO 8601)
     */
    recorded?: string;
    /**
     * Whether this is from primary source
     */
    primarySource?: boolean;
    /**
     * Body site element ID
     */
    site?: string;
    /**
     * Route of administration element ID
     */
    route?: string;
    /**
     * Dose quantity value
     */
    doseQuantity?: number;
    /**
     * Dose sequence element ID (1st, 2nd, booster, etc.)
     */
    sequence?: string;
    /**
     * Performer information
     */
    performer?: PerformerDto;
    /**
     * Note
     */
    note?: NoteDto;
    /**
     * Reason code element IDs
     */
    reasonCode?: Array<string>;
    /**
     * Reason references
     */
    reasonReference?: Array<ReferenceDto>;
    /**
     * Protocol applied
     */
    protocolApplied?: ProtocolAppliedDto;
    /**
     * Vaccine lot number
     */
    lotNumber?: string;
    /**
     * Vaccine manufacturer element ID
     */
    manufacturer?: string;
    /**
     * Location ID where immunization was administered
     */
    locationId?: string;
    /**
     * Expanded location data (if expand=location)
     */
    location?: LocationExpandDto;
    /**
     * Expanded immunization type data (if expand=immunizationType)
     */
    immunizationType?: ImmunizationTypeResponseDto;
    /**
     * Vaccine expiration date (ISO 8601)
     */
    expirationDate?: string;
    /**
     * Reactions information
     */
    reactions?: Array<ReactionDto>;
    /**
     * Additional metadata
     */
    metadata?: any;
    /**
     * Creation timestamp (ISO 8601)
     */
    createdOn: string;
    /**
     * Last modification timestamp (ISO 8601)
     */
    updatedOn?: string;
}
export namespace ImmunizationResponseDto {
    export type StatusEnum = 'completed' | 'entered-in-error' | 'not-done';
    export const StatusEnum = {
        Completed: 'completed' as StatusEnum,
        EnteredInError: 'entered-in-error' as StatusEnum,
        NotDone: 'not-done' as StatusEnum
    };
}


